<template>
  <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Periodicidade:"
    id="selectPeriodicidade"
    placeholder="Selecione a Periodicidade"
    :multiple="false"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'
import { ListGoalPeriods } from '@/enums/enumGoalMetricTypes.js'

export default {
  name: 'NxSelectPeriodicidade',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    initialValue: {
      required: false
    },
    value: {
      required: true
    }
  },
  mounted () {
    if (this.initialValue !== undefined && this.initialValue !== null && this.listOptions.length > 0) {
      this.localValue = this.initialValue
    } else {
      this.localValue = this.value
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
    }
  },
  data () {
    return {
      listOptions: [
        {value: ListGoalPeriods.MENSAL, text: 'Mensal'},
        {value: ListGoalPeriods.BIMESTRAL, text: 'Bimestral'},
        {value: ListGoalPeriods.TRIMESTRAL, text: 'Trimestral'}
      ],
      localValue: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
      this.$emit('update:value', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectPeriodicidade.vue